import React, { Component } from "react";
import theme from "../../Theme/theme";

const pageSizeOptions = [5, 10, 20, 25, 50, 100];
const ROWS_TEXT = " rows"

let PageButton = props => {
  return (
    <div
      style={style.pageButton}
      //   key={props.index}
      onClick={e => {
        // props.setPage(props.index);
        props.action();
      }}
    >
      {props.actionText}
    </div>
  );
};
let PageInput = props => {
  return (
    <input
      style={style.pageNumberInput}
      type="number"
      onChange={e => {
        props.setPage(e.target.value - 1);
      }}
      min={1}
      max={Math.ceil(props.pageCount)}
      defaultValue={props.selected + 1}
      value={props.selected >= 0 ? props.selected + 1 : ""}
    />
  );
};
class Pagination extends Component {
  render() {
    let buttons = [];
    buttons.push(
      <PageButton
        key={"Prev"}
        selected={this.props.currentPage}
        setPage={this.props.pageAction}
        actionText={"Prev"}
        action={() => {
          if (this.props.currentPage - 1 >= 0) {
            this.props.pageAction(this.props.currentPage - 1);
          }
        }}
      />
    );
    buttons.push(
      <PageInput
        key={"PageValue"}
        selected={this.props.currentPage}
        setPage={this.props.pageAction}
        pageCount={this.props.pageCount}
      />
    );
    buttons.push(
      <PageButton
        key={"Next"}
        selected={this.props.currentPage}
        setPage={this.props.pageAction}
        actionText={"Next"}
        action={() => {
          if (this.props.currentPage + 1 < this.props.pageCount) {
            this.props.pageAction(this.props.currentPage + 1);
          }
        }}
      />
    );
    buttons.push(
      <select key={"select_options"} style={style.dropDown} onChange={e => this.props.updateRowCount(e.target.value)}>
        {pageSizeOptions.map((option, i) => (
          <option key={i} selected={this.props.rowCount == option} value={option}>
            {option + ROWS_TEXT}
          </option>
        ))}
      </select>
    );
    return <div style={style.wrapper}>{buttons}</div>;
  }
}

const style = {
  wrapper: {
    display: "flex",
    padding: "10px",
    flexWrap: "wrap",
    maxWidth: "80%",
    alignItems: "center"
  },
  pageButton: {
    width: "55px",
    height: "35px",
    backgroundColor: "rgba(66, 219, 244, 0.42)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "2px",
    border: "1px solid #fff",
    borderRadius: "5px",
    cursor: "pointer",
    margin: "25px"
  },
  pageButtonSelected: {
    backgroundColor: "#fff"
  },
  pageNumberInput: {
    fontSize: "20px",
    height: "40px",
    width: "40px",
    textDecoration: "none",
    padding: "10px",
    border: "1px solid gray",
    borderRadius: "10px",
    textAlign: "center"
  },
  dropDown: {
    width: 100,
    fontSize: 18,
    height: 35,
    backgroundColor: theme.color.textLightWhite
  },
};
export default Pagination;
